import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[body-large]'
})
export class BodyLargeDirective {
  @HostBinding('class.body-large') readonly baseClass = true;

  @Input() emphasized: boolean | '' = false;

  @HostBinding('class.body-large--emphasized')
  get emphasizedClassActive() {
    return this.emphasized === '' || !!this.emphasized;
  }
}
